let obj = {
    locales: [],
    image:''
}

export default obj